// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// Afidium
import { CardFormModule } from 'libraries/module/formbuilder/forms/card-form/card-form.module';
import { ButtonModule } from 'libraries/module/formbuilder/fields/button/button.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { ProcessingSmsFormComponent } from './processing-sms-form.component';
import { BackButtonModule } from 'app_sasha/shared/components/back-button/back-button.module';
import { SimpleTextareaFieldWithVariablesModule } from 'libraries/module/formbuilder/fields/simple-textarea-field-with-variables/simple-textarea-field-with-variables.module';
import { SmsTextGenerationModule } from 'libraries/service/resources/sms-text-generation/sms-text-generation.module';
import { BreadcrumbModule } from 'libraries/component/breadcrumb/breadcrumb.module';
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';

@NgModule({
    declarations: [
        ProcessingSmsFormComponent,
    ],
    imports: [
        CommonModule,
        SimpleTextareaFieldWithVariablesModule,
        CardFormModule,
        ButtonModule,
        ReactiveFormsModule,
        FormsModule,
        CardModule,
        BreadcrumbModule,
        LoaderModule,
        BackButtonModule,
        SmsTextGenerationModule,
        TitleServiceModule,
    ],
    exports: [
        ProcessingSmsFormComponent,
    ],
    providers: [
    ],
})
export class ProcessingSmsFormModule { }